<template>
  <div class="layout-statement">
    <div class=" mx-auto max-w-md px-8 pb-6"> <slot name="title" /> <slot /> </div>
  </div>
</template>

<script>
export default {}
</script>
